import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import "./i18n";
import { ThemeProvider, CssBaseline } from '@mui/material';
import customTheme from "./plugin/mui";
import AppProvider from './providers/AppProvider';
import { Toaster } from 'react-hot-toast';
import "../src/assets/css/style.css";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <ThemeProvider theme={customTheme}>
      {/* CssBaseline injects global styles (including the font-family defined
          in the theme) and normalizes browser inconsistencies. */}
      <CssBaseline />
      <AppProvider>
        <App />
        <Toaster />
      </AppProvider>
    </ThemeProvider>
  </>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
